import { createUseStyles } from 'react-jss';
import { BreakPoints, mediaQuery } from '@picsart/cascade/index';

export default createUseStyles(
  () => ({
    wrapper: {
      backgroundColor: 'var(--x-bg-5)',
      borderRadius: 16,
      padding: [16, 24],
      marginBottom: 24,
    },
    rootContainer: {
      maxWidth: 1360,
      padding: [56, 48],
      borderRadius: 32,
      margin: '0 auto',

      [mediaQuery(468)]: {
        padding: [40, 24],
      },
    },
    title: {
      color: 'var(--x-text-color-1)',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 42,
      lineHeight: '72px',
      textAlign: 'center',
      [mediaQuery(768)]: {
        fontSize: 30,
        lineHeight: '36px',
      },
    },
    list: {
      display: 'grid',
      gap: 18,
      gridTemplateColumns: '1fr 1fr 1fr',
      marginBlockEnd: 40,

      [mediaQuery(BreakPoints.Small)]: {
        gridTemplateColumns: '1fr 1fr',
      },
      [mediaQuery(BreakPoints.Medium)]: {
        gridTemplateColumns: '1fr',
      },
    },
    smallHeading: {
      color: 'var(--x-text-color-1)',
      marginBottom: 12,
      textAlign: 'center',
      fontSize: '20px !important',
      lineHeight: '28px',
    },
  }),
  { name: 'footer-related-links' },
);
